(function ($) {
  console.log('abc');
  const objParams = Object.fromEntries(new URLSearchParams(window.location.search));

  function initPartnerLogin() {
    $("#api .heading > h1").hide();
    $(".forgot-password").hide();
    $(".forgot-password").insertBefore(".working");
    $(".forgot-password").show();
    $(".entry-item").addClass("form__control");
    $("label[for='logonIdentifier']").insertAfter("#logonIdentifier");
    
    $("label[for='email']").insertAfter("#email");

    $("label[for='password']").insertAfter("#password");
    $(".show-password").insertAfter( "label[for='password']");
    $(".localAccount button").addClass("button button--enforce-min-width button--orange submit-form")
                              .text("Sign in");
    $("label[for='logonIdentifier']").text("Email");
    
    $("label[for='logonIdentifier'], label[for='password'], label[for='email']").addClass("float-label"); 
    
    var txtTrim = $("label[for='email']").text().trim();
    $("label[for='email']").text(txtTrim);

    $("#logonIdentifier, #password, #email").attr("required","");
    $("#logonIdentifier, #password, #email").attr("data-validate", "required");
    $("#logonIdentifier, #password, #email").attr("placeholder", "")
                                            .addClass("form__input");

    $("#logonIdentifier").attr("type","text");

    $(".toggle-password").insertAfter("label[for='password']");
    $(".error.itemLevel").insertAfter(".entry-item label");
    
    setTimeout(function(){ 
      $('html, body').animate({
        scrollTop: $(".main").offset().top
      }, 500);
    }, 2000);
    
    var inputRequired = $('input[required="required"]');
    
    inputRequired.change( function() {
      if($(this).val().trim() !== ''){
        $(this).attr('data-empty','false');
      }
      else $(this).attr('data-empty','true');
    });
  }

  // handle partner type
  function initStaffLogin() {
    const staffWrapper = $('#api .claims-provider-list-buttons');

    staffWrapper.find('.intro').hide();

    staffWrapper.find('.options .accountButton')
                .addClass('button button--enforce-min-width button--orange submit-form')
                .text("Sign in");

    if (objParams?.partner_type === 'staff') {
      showStaffLoginForm();
    } else {
      showPartnerLoginForm();
    }

    $('[data-layout="login-page"]').show();
  };

  function showStaffLoginForm() {
    $('.login-form-wrapper .mask__header .page__title').text("Staff Login");
    $('#localAccountForm, #login-section .login__register-link, .mask__header > p').hide();
    $('#api .claims-provider-list-buttons').show();

    if (objParams?.error || objParams?.login_error) {
      const errMesg = objParams?.error || objParams?.login_error;

      $('#api .claims-provider-list-buttons .options').after(`
        <div class="alert alert--error reg--error">
          <span class="alert__title reg--error--title">
            ${errMesg.replaceAll('-', ' ')}
          </span>
        </div>
      `);
    }
  }

  function showPartnerLoginForm() {
    $('#localAccountForm, .login__register-link, .mask__header > p').show();
    $('.claims-provider-list-buttons').hide();

    if (objParams?.error || objParams?.login_error) {
      const errMesg = objParams?.error || objParams?.login_error;

      $('#api #localAccountForm [data-elm="forgot-password"]').after(`
        <div class="alert alert--error reg--error">
          <span class="alert__title reg--error--title">
            ${errMesg.replaceAll('-', ' ')}
          </span>
        </div>
      `);
    }
  }

  function showPassword() {
    $('.toggle-password').off('click.showPsw').on('click.showPsw', function (event) {
      var target = $(this);

      target.toggleClass("show-password");

      var input = $(target.attr("toggle"));

      if (input.attr("type") == "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }

      event.preventDefault();

    });
  }

  //  Add text for Social login button
  function addTextLoginButton() {
    var btnFacebookLogin = $('#FacebookExchange');
    var btnGoogleLogin = $('#GoogleExchange');
    var btnLineLogin = $('#LineAppLogin');

    if (window.innerWidth > 1200) {
      btnFacebookLogin.text('Facebook Login');
      btnGoogleLogin.text('Google Login');
      btnLineLogin.text('Line Login');
    } else {
      btnFacebookLogin.text('Facebook');
      btnGoogleLogin.text('Google');
      btnLineLogin.text('Line');
    }
  };

  //  Move social login
  function moveSocialLogin() {
    var wrapLogin = $('#login-section .box__content #api');
    var socialLogin = $('#login-section .social');
    var registerButton = $('#login-section .login__register-link');
    
    wrapLogin.append(registerButton);
    wrapLogin.append(socialLogin);
  };

  $(function() {
    showPassword();
    initPartnerLogin();
    initStaffLogin();
    // addTextLoginButton();
    // moveSocialLogin();
  })
}(jQuery));
